import toolutil from "@/utils/toolutil";
/* @description:主要处理异步任务执行完毕后，回调调用方函数功能，需要处理任务超时回调问题,单例模式
 * @author: 宋建国
 * @date: 2021-05-30 11:09:47
 * @version: V1.0
*/

var xyjTaskQueue = (function (){
    /* @description:任务队列构造行数
     * @author: 宋建国
     * @date: 2021-05-30 11:27:16
     * @version: V1.0
    */
    function xyjTaskQueue(){
        this.InProcess = {}; //任务队列对象
        this.overtime = 1000; //默认超时，单位毫秒
        this.maxTaskNumber = 10;
        this.TaskTimes = null;
    }
    
    var runState = {
        RUNSUCCESS: 1, //运行成功
        INITIAL: 0 //进入队列初始值
    }
    /**@description: 定时器处理任务队列
     *@functionName: createTaskTimes
     *@author: 宋建国
     *@date: 2021-05-30 23:39:10
     *@version: V1.0
    */
    function createTaskTimes(){
        let taskQueue = this;
        return setInterval(function(){
            let waitDel = [];
            for(let eventNameRandomNumber in taskQueue.InProcess){
                try{
                    if(taskQueue.InProcess[eventNameRandomNumber].state === runState.RUNSUCCESS){
                        waitDel.push(eventNameRandomNumber);
                        taskQueue.InProcess[eventNameRandomNumber].callback(runState.RUNSUCCESS,taskQueue.InProcess[eventNameRandomNumber].runresult);
                    }else{
                        /*@Description: 判断任务是否超时
                         *@Author: 宋建国
                         *@Date: 2021-05-30 23:29:20
                         *@version V1.0
                        */
                        let tmpOvetTime = new Date().getTime() - taskQueue.InProcess[eventNameRandomNumber].StartTime;
                        console.info("超时计算：" + tmpOvetTime);
                        console.info("超时等待：" + taskQueue.InProcess[eventNameRandomNumber].overtime);
                        if(tmpOvetTime>=taskQueue.InProcess[eventNameRandomNumber].overtime){
                            waitDel.push(eventNameRandomNumber);
                            taskQueue.InProcess[eventNameRandomNumber].callback(runState.INITIAL,{error:"超时"});
                        }
                    }
                }catch(err){
                    console.error(err);
                }
            }
            for(let index in waitDel){
                delete taskQueue.InProcess[waitDel[index]];
            }
        }, 1000);
    }
    /**@description: 获取任务数
     *@functionName: attributeCount
     *@author: 宋建国
     *@date: 2021-05-30 22:54:10
     *@version: V1.0
    */
    xyjTaskQueue.prototype.attributeCount = function(){
        return Object.keys(this).length;
    }
    /**@description: 增加任务到任务队列
     *@functionName: _addTaskQueue
     *@params1: taskQueue:队列实列本身
     *@params2: eventNameRandomNumber：任务唯一编码
     *@params3: dallback：任务回调函数
     *@author: 宋建国
     *@date: 2021-05-30 15:51:15
     *@version: V1.0
    */
    function _addTaskQueue(taskQueue,eventNameRandomNumber,callback,overtime){
        if(typeof callback !== "function"){
            throw new TypeError("回调对象必须是函数类型");
        }
        if(typeof eventNameRandomNumber !== "string"){
            throw new TypeError("eventNameRandomNumber参数，请出入字符产类型");
        }
        if(toolutil.isBlank(eventNameRandomNumber)){
            throw new Error("传入eventNameRandomNumber参数不能为空");
        }

        if(taskQueue.attributeCount()>taskQueue.maxTaskNumber){
            throw new Error("任务队列已经满请稍后装入");
        }
        if(taskQueue.InProcess[eventNameRandomNumber]){
            throw new Error("eventNameRandomNumber任务唯一编号已经存在");
        }
        taskQueue.InProcess[eventNameRandomNumber]={
            StartTime: new Date().getTime(),
            state: runState.INITIAL,
            overtime: overtime===null ? taskQueue.overtime : overtime,
            runresult : null,
            callback: callback
        }
        if(taskQueue.TaskTimes === null){ //创建定时器
            taskQueue.TaskTimes = createTaskTimes.call(taskQueue);
        }
        return taskQueue.InProcess[eventNameRandomNumber];
    }
    /**@description: 增加任务到任务队列
     *@functionName: addTaskQueue
     *@params1: 参数1 eventNameRandomNumber，任务唯一编号
     *@params2: 参数2 callback，任务回调函数
     *@params3: 参数3 overtime,超时毫秒
     *@author: 宋建国
     *@date: 2021-05-31 00:13:40
     *@version: V1.0
    */
    xyjTaskQueue.prototype.addTaskQueue = function(eventNameRandomNumber,callback,overtime){
        try{
            let tmpTask =  _addTaskQueue(this,eventNameRandomNumber,callback,overtime);
            return tmpTask;
        }catch(err){
            throw new Error(err);
        }
    }
    xyjTaskQueue.prototype.mqttOpcItemWrite = function(message,callback,overtime) {
        try{
            if(!window.xyjVue.$tu.isFunction(callback)){
                callback(runState.INITIAL,null);
                console.error("callback回调函数参数必须是函数");
                return;
            }
            if(!window.xyjVue.OPCITEMWRITE){
                callback(runState.INITIAL,null);
                console.error("请在config.json配置文件中配置主题命令主题OPCITEMWRITE");
                return;
            }
            let topic = window.xyjVue.OPCITEMWRITE + sessionStorage.getItem("branchId");
            let eventNameRandomNumber = sessionStorage.getItem("user") +  window.xyjVue.$tu.createRandom();
            if(!message.eventNameRandomNumber){
                message["eventNameRandomNumber"] = eventNameRandomNumber;
            }else{
                message.eventNameRandomNumber = eventNameRandomNumber;
            }
            if(!message.eventTyep){
                message["eventTyep"] = "OPCITEMWRITE";
            }else{
                message.eventTyep = "OPCITEMWRITE";
            }
            let tmpTask =  _addTaskQueue(this,message.eventNameRandomNumber,callback,overtime);
            window.topology.mqtt.publish(topic,JSON.stringify(message));
            return tmpTask;
        }catch(err){
            callback(runState.INITIAL,null);
            console.error(err);
            throw new Error(err);
        }
    }
    /**@description: 任务正常结束方法
     *@functionName: TaskQueueSuccess
     *@params1: 参数1 eventNameRandomNumber任务唯一编码
     *@params2: 参数2 dataValue: 任务正常成功JSON格式字符串
     *@author: 宋建国
     *@date: 2021-05-30 23:53:44
     *@version: V1.0
    */
    xyjTaskQueue.prototype.TaskQueueSuccess = function(dataValue){
        let tmpValue;
        if(typeof dataValue === "string"){
            try{
                tmpValue = JSON.parse(dataValue);
            }catch(err){
                console.error(err);
                return;
                //throw new Error(err);
            } 
        }else{
            tmpValue =  dataValue;
        }
        if(!tmpValue.eventNameRandomNumber){
            console.error("eventNameRandomNumber命令唯一ID不存在");
            return;
        }
        let task = this.InProcess[tmpValue.eventNameRandomNumber];
        if(task === null || task === undefined){
            return null;
        }
        if(task.state){
            task.state = runState.RUNSUCCESS;
        }else{
            task["state"] = runState.RUNSUCCESS;
        }
        if(task.runresult){
            task.runresult = tmpValue;
        }else{
            task["runresult"] = tmpValue; 
        }
    }
    return new xyjTaskQueue();
}());
export {xyjTaskQueue};




// WEBPACK FOOTER //
// ./src/utils/xyjTaskQueue.js